import { useEffect } from "react";
import type { RefreshMethod } from "../types";
import { tokenRefreshInterceptor } from "../utils";

export function useTokenRefreshInterceptor(refresh: RefreshMethod) {
  useEffect(() => {
    tokenRefreshInterceptor.setRefreshMethod(refresh);
  }, [refresh]);
}
